var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "blockchain_data_table"
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.blockchains,
      "headers": _vm.headers,
      "multi-sort": "",
      "mobile-breakpoint": 0,
      "dark": _vm.$root.theme === 'night'
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "value"
        }, [_vm.links ? _c('a', {
          staticClass: "chain_name",
          attrs: {
            "href": _vm.generateURL("/blockchain/".concat(item.id), item)
          }
        }, [_vm._v(_vm._s(item.name))]) : _c('span', {
          staticClass: "chain_name"
        }, [_vm._v(" " + _vm._s(item.name) + " ")])])];
      }
    }, {
      key: "item.indexed",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('Indexed', {
          attrs: {
            "indexed": item.indexed,
            "indexed-label": false,
            "not-indexed-label": false
          }
        })];
      }
    }, {
      key: "item.vmID",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticClass: "value"
        }, [_c('p', [_vm._v(_vm._s(_vm.vmFullName(item.vmID) || '--'))]), _c('p', {
          staticClass: "vm_abbrev"
        }, [_vm._v(_vm._s(_vm.vm(item.vmID)))])])];
      }
    }])
  }, [[_c('div', {
    staticClass: "value"
  }, [_vm._v(" item.subnetID | subnet ")])]], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }